var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6873_6086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.294 250.337L2.51843e-05 256.821C-0.00359555 258.794 0.38323 260.748 1.13821 262.571C1.8932 264.394 3.00142 266.049 4.39903 267.442L245.446 507.646C248.259 510.45 253.091 511.987 255.928 512C258.81 512.013 263.739 510.496 266.601 507.643L507.607 267.288C509.001 265.897 510.107 264.245 510.861 262.426C511.615 260.607 512.003 258.657 512.002 256.688L498.704 250.338H338.74L249.01 279.303L173.121 250.338L15.294 250.337Z",
    fill: "#FFB739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.996 256.689C511.996 260.554 510.508 264.39 507.601 267.286L266.597 507.641C263.761 510.477 258.876 511.996 256 511.996V277.044L338.739 250.337H498.703L511.996 256.689Z",
    fill: "#FF9441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.119 250.337L256 511.996L338.738 250.337H173.119Z",
    fill: "#FF9441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.738 250.337L256 511.996V250.337H338.738Z",
    fill: "#FF7149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.487 248.362L429.26 128.159C428.155 126.507 426.731 125.091 425.073 123.995L417.801 127.487L269.879 128.409L256 121.494L244.784 128.565L97.195 129.485L86.896 124.01C85.245 125.106 83.8282 126.519 82.728 128.167L2.50701 248.521C0.868491 250.979 -0.00399368 253.867 1.37431e-05 256.821L512 256.686C512.006 253.724 511.131 250.826 509.487 248.362Z",
    fill: "#FFD17E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.996 256.689C493.399 256.689 374.624 256.729 256 256.759V121.494L269.883 128.405L417.802 127.486L425.073 123.99C426.729 125.09 428.151 126.505 429.258 128.155L509.49 248.358C511.137 250.824 512.009 253.725 511.996 256.689ZM95.1934 121.494C92.1974 121.494 89.3234 122.395 86.8994 124.008L175.755 256.775H175.765L255.995 121.494H95.1934Z",
    fill: "#FFB739"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.264 256.733L425.07 123.993C422.619 122.365 419.742 121.497 416.799 121.495H255.995L336.2 256.734H336.264V256.733Z",
    fill: "#FF9441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.424 361.319C141.349 361.319 120.948 340.919 120.948 315.844C120.948 307.56 114.232 300.844 105.948 300.844C97.6637 300.844 90.9477 307.56 90.9477 315.844C90.9477 340.793 70.6707 361.319 45.4727 361.319C37.1887 361.319 30.4727 368.035 30.4727 376.319C30.4727 384.603 37.1887 391.319 45.4727 391.319C70.5477 391.319 90.9477 411.719 90.9477 436.794C90.9477 445.078 97.6637 451.794 105.948 451.794C114.232 451.794 120.948 445.078 120.948 436.794C120.948 411.847 141.223 391.319 166.424 391.319C174.708 391.319 181.424 384.603 181.424 376.319C181.424 368.035 174.708 361.319 166.424 361.319Z",
    fill: "#FFD17E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.329 60.475C371.254 60.475 350.854 40.075 350.854 15C350.854 6.716 344.138 0 335.854 0C327.57 0 320.854 6.716 320.854 15C320.854 40.075 300.455 60.475 275.379 60.475C267.095 60.475 260.379 67.191 260.379 75.475C260.379 83.759 267.095 90.475 275.379 90.475C300.454 90.475 320.854 110.875 320.854 135.95C320.854 144.234 327.57 150.95 335.854 150.95C344.138 150.95 350.854 144.234 350.854 135.95C350.854 110.875 371.253 90.475 396.329 90.475C404.613 90.475 411.329 83.759 411.329 75.475C411.329 67.191 404.613 60.475 396.329 60.475Z",
    fill: "#FFB739"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6873_6086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.29c46778041c1a7030d7286cead1aa3c.svg";
export { ForwardRef as ReactComponent };